import React, { FC } from 'react';
import Rate from '../../../../../presentational/financeElements/rate/Rate';
import { RateTypes } from '../../../../../../enum/RateTypes';
import { IFinanceQuote } from '../../../../../../../common/model/IFinanceQuote';
import { useSelector } from 'react-redux';
import currentDealSelectors from '../../../../../../store/selectors/currentDealSelectors';

const MonthlyInterestContainer: FC = () => {
  const interestRate: IFinanceQuote = useSelector(currentDealSelectors.getFinanceQuoteInterestRate);

  return <Rate labelId={RateTypes.INTEREST_RATE} value={`${interestRate}%`} />;
};

export default MonthlyInterestContainer;
